import React, { useState } from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 4,
  textAlign: 'center',
};

const SessionExpiredModal = ({ open, onLogin }) => {
  return (
    <Modal open={open}>
      <Box sx={style}>
        <Typography variant="h6" component="h2" gutterBottom>
          Session Expired
        </Typography>
        <Typography variant="body1" sx={{ mb: 3 }}>
          Your session has expired due to inactivity. Please login again to continue.
        </Typography>
        <Button variant="contained" color="primary" onClick={onLogin}>
          Login Again
        </Button>
      </Box>
    </Modal>
  );
};

// Example usage
export default function SessionExpiredModal1() {
  const [isSessionExpired, setIsSessionExpired] = useState(true);

  const handleLogin = () => {
    // Redirect to login page or trigger login flow
    window.location.href = '/r/login';
  };

  return (
    <>
      {/* Other app content */}
      <SessionExpiredModal open={isSessionExpired} onLogin={handleLogin} />
    </>
  );
}
